export default "__VITE_ASSET__BXuoeUpp__"